<template>
  <ul class="Breadcrumb">
    <li
      v-for="(item, index) in breadcrumb"
      :key="item.text"
      class="Breadcrumb__item"
    >
      <Icon v-if="index !== 0" iconName="Right" class="Breadcrumb__icon" />
      <router-link v-if="item.link" :to="item.link">{{
        item.text
      }}</router-link>
      <span v-else>{{ item.text }}</span>
    </li>
  </ul>
</template>

<script>
import Icon from '@spectee/components/Atoms/IconBase/index.vue';

export default {
  name: 'BreadcrumbBase',
  components: { Icon },
  props: {
    breadcrumb: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.Breadcrumb {
  display: flex;

  &__item {
    display: flex;
    align-items: center;
    font-size: $service-font-size-pp;
  }

  & &__icon {
    width: $service-unit * 4;
    height: $service-unit * 4;
    color: $color-gray-80;
  }

  @media (max-width: 320px) {
    &__item {
      font-size: $service-font-size-ppp;
    }
  }
}
</style>
